.background{
  align-items: center;
  background-color: var(--pgm-sys-color-surface);
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  gap: var(--pgm-sys-spacing-10);
  height: 100vh;
  justify-content: center;
  margin-inline: auto;
  width: 100%;
}

.text{
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.title{
  color: var(--pgm-sys-color-on-surface);
}

.details{
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
}

@media (max-width: 768px){
  .background{
    align-items: stretch;
    box-sizing: border-box;
    flex-direction: column;
    height: auto;
    justify-content: flex-start;
    min-height: 100vh;
    padding: var(--pgm-sys-spacing-6);
  }

  .text{
    order: 1;
    width: 100%;
  }

  .text br{
    display: none;
  }

  .illustration{
    display: flex;
    justify-content: center;
    order: 2;
    width: 100%;
  }

  .illustration img{
    display: block;
    height: auto;
    max-width: 100%;
  }
}

.embedded{
  height: auto;
  justify-content: flex-start;
  min-height: 0;
  padding: 0;
}
